module.exports = __webpack_public_path__ + "images/icon/print-4a7d26e0.svg";